import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  subContainer: {
    borderRadius: "15px",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  containerRoot: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "94px",
    justifyContent: "space-between",
  },
  subContainerStepper: {
    borderRadius: "15px",
    padding: "30px 10px 30px 10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: colors.bgcolor,
  },
  subsubContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "25px 15px 25px 15px",
    gap: "10px",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "15px",
    gap: "20px",
    width: "100%",
  },
});

export default useStyles;
